export default {
  id: null,
  nome: null,
  abreviacao: null,
  cor: null,
  corTexto: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/tagmodel.js